import { IDataSource } from "./../../models/IDataSource";
import { DATASOURCES_GET_DATASOURCES } from "./data-sources-types";

export const getDataSources = (dataSources: IDataSource[] | undefined) => (dispatch: any) =>
  dispatch({ type: DATASOURCES_GET_DATASOURCES, payload: dataSources });
